import React from 'react';
import styled, { css } from 'styled-components';
import { CardProps } from '../../types';

type CardBaseProps = Omit<CardProps, 'hover'> & { $hover?: boolean };

const CardBase = styled.div<CardBaseProps>`
  background: ${({ theme }) => theme.colors.surface};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.borderRadius.lg};
  transition: all ${({ theme }) => theme.transitions.normal};
  position: relative;
  overflow: hidden;
  cursor: ${({ onClick }) => onClick ? 'pointer' : 'default'};

  ${({ $hover = false }) => $hover && css`
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 8px 25px rgba(30, 58, 138, 0.15);
      border-color: ${({ theme }) => theme.colors.navyBlue};
    }
  `}

  ${({ padding = 'lg', theme }) => {
    switch (padding) {
      case 'sm':
        return css`
          padding: ${theme.spacing.sm};
        `;
      case 'md':
        return css`
          padding: ${theme.spacing.md};
        `;
      case 'xl':
        return css`
          padding: ${theme.spacing.xl};
        `;
      default:
        return css`
          padding: ${theme.spacing.lg};
        `;
    }
  }}
`;

export const Card: React.FC<CardProps> = ({
  children,
  className,
  hover = false,
  padding = 'lg',
  onClick,
  ...props
}) => {
  return (
    <CardBase
      className={className}
      $hover={hover}
      padding={padding}
      onClick={onClick}
      {...props}
    >
      {children}
    </CardBase>
  );
}; 